<div class="group">
  <div class="group-header">
    <div class="name" *ngIf="title">{{ title }}</div>
    <div class="name" *ngIf="!title">{{ group.name }}</div>
    <div class="param">Игры</div>
    <div class="param">Очки</div>
    <ng-container *ngIf="tournament.sport.isFootball()">
      <div class="param">Разница<br/>З/П</div>
    </ng-container>
    <ng-container *ngIf="tournament.sport.isBasketball()">
      <div class="param">% побед</div>
    </ng-container>
  </div>
  <div class="teams">
    <div class="loading" *ngIf="loading"><mtg-spinner></mtg-spinner></div>
    <ng-container *ngIf="!loading">
      <a
        *ngFor="let team of teams; let i = index;"
        [routerLink]="getTeamRoute(team.tournamentTeam.team.id)"
        [queryParams]="teamQueryParams"
        queryParamsHandling="merge"
        class="team">
        <div class="place">{{ i + 1 }}</div>
        <div class="logo">
          <img [src]="team.tournamentTeam.logo.path" *ngIf="team.tournamentTeam.logo.path">
          <div [ngClass]="team.tournamentTeam.team.getEmptyLogoClass()" *ngIf="!team.tournamentTeam.logo.path"></div>
        </div>
        <div class="name">{{ team.tournamentTeam.name }}</div>
        <div class="param">
          {{ team.gamesCount || 0 }}
        </div>
        <div class="param">
          {{ team.points || 0 }}
        </div>
        <div class="param" *ngIf="tournament.sport.isBasketball()">
          {{ team.gamesWonPercent || 0 }}%
        </div>
        <ng-container *ngIf="tournament.sport.isFootball()">
          <div class="param">
            {{ team.scoreSum > team.missedSum ? '+' : ''}}
            {{ team.scoreSum - team.missedSum }}
          </div>
        </ng-container>
      </a>
    </ng-container>
  </div>
</div>
